import { ref } from "vue";

// Выноски-подсказки у кнопок правой панели редактора. Состояние общее на
// модуль: включаются из меню «Действия» нижней панели, а рисуются в
// RouteEditorContextPanel. Закрываются любым следующим тапом.
const hintsOpen = ref(false);

const closeHints = () => {
  hintsOpen.value = false;
  window.removeEventListener("pointerdown", closeHints, true);
};

const toggleHints = () => {
  if (hintsOpen.value) {
    closeHints();
    return;
  }
  hintsOpen.value = true;
  // Слушатель вешаем в следующем тике, иначе этот же тап сразу закроет выноски.
  window.setTimeout(() => {
    if (hintsOpen.value) window.addEventListener("pointerdown", closeHints, true);
  }, 0);
};

export const useRouteEditorHints = () => ({ hintsOpen, toggleHints, closeHints });
